import { red } from '@ant-design/colors'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Modal, type ModalFuncProps } from 'antd'

const { confirm } = Modal
type Props = {
  onConfirm: () => void
  options?: Pick<ModalFuncProps, 'title' | 'content' | 'okText'>
}

export const showDeleteConfirmationModal = ({
  onConfirm,
  options = {
    title: 'Удаление',
    content: 'Вы уверены, что хотите удалить запись?',
    okText: 'Удалить',
  },
}: Props) => {
  confirm({
    icon: <ExclamationCircleOutlined />,
    title: options.title,
    content: options.content,
    okText: options.okText,
    okType: 'danger',
    cancelText: 'Отмена',
    centered: true,
    okButtonProps: {
      style: {
        backgroundColor: red[5],
        color: 'white',
      },
    },

    onOk() {
      onConfirm()
    },
    onCancel() {},
  })
}
